import { Spin } from "antd";
import { CascadeFailed } from "components/UI/Cascade/CascadeFailed.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";
import { useEffect } from "react";
import { CascadeProcessItemAction } from "types/enums.ts";

import GetCascadeProcessResponse = App.Http.Responses.Cascade.GetCascadeProcessResponse;

interface CascadePriorityRedirectProps {
    cascade: GetCascadeProcessResponse;
    tenantSlug: string;
    processId: string;
}

export const CascadePriorityRedirect = ({ cascade, tenantSlug, processId }: CascadePriorityRedirectProps) => {
    const { t } = usePaldockTranslation("ui.cascade");

    // Find the first priority redirect item with a non-null URL
    const redirectItem = cascade.items?.find(
        (item) => item.action === CascadeProcessItemAction.PriorityRedirect && item.url !== null
    );

    useEffect(() => {
        if (redirectItem && redirectItem.url) {
            handlePriorityRedirect(redirectItem.id);
        }
    }, [cascade]);

    const handlePriorityRedirect = async (itemId: string | null) => {
        if (!itemId) {
            return;
        }
        window.location.href = `${import.meta.env.VITE_BACKEND_URL ?? "localhost"}/api/${tenantSlug}/processes/${processId}/${CascadeProcessItemAction.Redirect}/${itemId}`;
    };

    if (!redirectItem) {
        return <CascadeFailed />;
    }

    return (
        <div className={"flex flex-col gap-2"}>
            <Spin size="large" />
            {t("content.redirecting")}
        </div>
    );
};
